const translations = {
    backButtonText: 'Back'
};

export default translations;
